;(function () {
  'use strict'
  angular.module('obex').factory('handledConversationService', [
    '$rootScope',
    '$http',
    'authService',
    function ($rootScope, $http, authService) {
      return {
        getHandlingData(fromNumber) {
          var loginMember = authService.getLoginMember()
          console.log(
            'call authService.getLoginMember() in alert.service ',
            loginMember,
          )
          return $http.get(
            '/handledConversation/' + fromNumber + '/' + loginMember.Id,
          )
        },
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./client/js/services/handledConversation.service.js